export interface IReturn_Parent
{
    Return_IdType_Message? : number;
    //Return_Id? :string; not use ?
    Return_Message? :string;
}

// export const Type_Return_Message = [
//     { Id: 0, Libelle: "Erreur" },
//     { Id: 1, Libelle: "Information" },
//     { Id: 2, Libelle: "Validation" }, 
//     { Id: 3, Libelle: "Autre" }, 
//   ];

  export const enum Type_Return_Message {
    Erreur = 0,
    Validation = 1,
    Autre = 2
  }
